<app-main-toolbar (toggleDrawer)="toggleDrawerForMobile(); drawer.toggle()" />

<div id="server-status">
  {{ serverStatusMessage() }}
</div>

<mat-sidenav-container class="sidenav-container">
  <mat-sidenav
    #drawer
    class="sidenav animated-sidenav"
    fixedInViewport="false"
    autoFocus="false"
    [disableClose]="true"
    [attr.role]="isMobile() ? 'dialog' : 'navigation'"
    [mode]="isMobile() ? 'over' : 'side'"
    (click)="isMobile() && drawer.toggle()"
    [opened]="isMobile() ? 'false' : 'true'"
    [class.open]="mainNavService.mainNavOpen()"
    [@onMainNavChange]="isDesktop() ? (mainNavService.mainNavOpen() ? 'open' : 'close') : null">
    <app-main-sidenav (closeDrawer)="isMobile() ? drawer.toggle() : null" />
  </mat-sidenav>

  <mat-sidenav-content
    [class]="{
      'main-content': true,
      open: isDesktop() ? mainNavService.mainNavOpen() : null,
      closed: isDesktop() ? !mainNavService.mainNavOpen() : null,
    }">
    <app-main-tabs />
  </mat-sidenav-content>
</mat-sidenav-container>
